{
  "ACTIONS": {
    "CREATE": "Create",
    "CANCEL": "Cancel",
    "SAVE": "Save",
    "NEXT": "Next",
    "BACK": "Back",
    "FINISH": "Finish",
    "APPLY": "Apply",
    "IMPORT": "Import",
    "SELECT": "Select",
    "SEARCH": "Search",
    "ADD": "Add",
    "DELETE": "Delete"
  },
  "ERRORS": {
    "GENERIC_MESSAGE": "Something went wrong",
    "GENERIC_LOAD_MESSAGE": "Could not load the page. Please try again.",
    "GENERIC_EDIT_MESSAGE": "There was an error updating. Please try again.",
    "RESOURCE_NOT_FOUND_ERROR": "Resource not found"
  },
  "OBJECT_TYPES": {
    "CONTACT": "Contact",
    "COMPANY": "Company"
  },
  "ASSOCIATIONS": {
    "ACTIONS": {
      "REMOVE": "Remove association",
      "DETAILS": "View Details",
      "EDIT_TAGS": "Edit association tags",
      "SHOW_MORE": "Show {{count}} more",
      "VIEW_ALL": "View all"
    },
    "SUCCESS": {
      "GENERIC": "Successfully created association",
      "PARTIAL_SUCCESS": "{{createdCount}} out of {{totalCount}} associations are created"
    },
    "COMPANY": {
      "TITLE": "Companies",
      "ADD_COMPANY": "Add company",
      "ERROR": "Failed to create an account for this company",
      "INVITE": "+ Invite to {{appName}}",
      "LAST_LOGIN_DATE": "Last login: {{lastLoginDate}}",
      "NEVER_LOGGED_IN": "Never"
    },
    "PARENT_CHILD_COMPANIES": {
      "TITLE": "Associated companies",
      "CHILD_SECTION_TITLE": "Child companies",
      "PARENT_SECTION_TITLE": "Parent company",
      "ADD_CHILD_COMPANY": "Add child company",
      "SET_PARENT_COMPANY": "Set parent company",
      "ADD_CHILD_COMPANY_MODAL": {
        "TITLE": "Add child company to {{companyName}}",
        "SUCCESS": "Child company added",
        "ERROR": "Error adding child company"
      },
      "SET_PARENT_COMPANY_MODAL": {
        "TITLE": "Set parent company for {{companyName}}",
        "SUCCESS": "Parent company set",
        "ERROR": "Error setting parent company"
      }
    },
    "APP_ACCESS_MODAL": {
      "TITLE": "Invite {{contactName}} to {{appName}}?",
      "DESCRIPTION": "They will be sent a welcome email and be added as a user for {{companyName}}.",
      "PERMISSIONS_INFO": "You can edit their permissions at any time under the <b>Customers > {{appName}} > Users</b> tab.",
      "INVITE": "Invite",
      "CANCEL": "Cancel",
      "SUCCESS": "Contact has been successfully invited",
      "ERROR": "Error inviting contact"
    },
    "MODAL": {
      "TITLE_CONTACT_MODAL": "Add associated companies to {{contactFullName}}",
      "ADD_ASSOCIATION": "Add company",
      "TITLE_COMPANY_MODAL": "Add associated contacts to {{companyName}}",
      "TITLE_ASSOCIATION": "Association details",
      "TITLE_TAGS": "Association tags",
      "HINT_TAGS": "New tag...",
      "DESCRIPTION_TAGS": "Use tags to describe this relationship",
      "CREATE_NEW_CONTACT": "Create new contact"
    },
    "COMPANY_MODAL": {
      "PRIMARY_COMPANY": "Set as primary company",
      "PRIMARY_DESCRIPTION": "This will replace any current primary company associations"
    },
    "ADMIN_NOTES": {
      "TITLE": "Admin Notes"
    },
    "PRODUCTS": {
      "TITLE": "Products",
      "NO_PRODUCTS": "No products yet",
      "ACTIVE_SINCE": "Active since",
      "RENEWS": "Renews",
      "COMMITTED_UNTIL": "Committed until",
      "TRIAL_SINCE": "Trial since",
      "ENDS": "Ends",
      "DAYS_REMAINING": "{{days}} days remaining",
      "TRIAL_UPGRADE": "Upgrade product to continue service",
      "ERROR": "Error loading data, refresh and try again",
      "STATUS": {
        "TRIAL": "Trial",
        "TRIAL_ENDED": "Trial ended"
      }
    },
    "REPORTS": {
      "TITLE": "Reports"
    },
    "OPPORTUNITIES": {
      "TITLE": "Opportunities"
    },
    "UTM_ATTRIBUTES": {
      "TITLE": "UTM Attributes"
    },
    "AUTOMATIONS": {
      "TITLE": "Automations"
    },
    "CAMPAIGNS": {
      "TITLE": "Campaigns",
      "ADD_ASSOCIATION": "Add campaign",
      "START": "Start campaign...",
      "START_NOW": "Campaign will start on",
      "START_LATER": "Campaign will start at the scheduled time",
      "ADD_TO_CAMPAIGN": "Add to campaign",
      "MODAL": {
        "SUCCESS": "Successfully added to campaign",
        "ERROR": "Error adding to campaign",
        "UPDATED": "Last updated:",
        "NO_CAMPAIGNS": "No campaigns found",
        "SEARCH_PLACEHOLDER": "Search active campaigns"
      },
      "START_CAMPAIGN": {
        "NOW": "Now",
        "LATER": "Later"
      },
      "VIEW_ALL": "View all"
    },
    "FILES": {
      "TITLE": "Files"
    },
    "FULFILLMENT_PROJECTS": {
      "TITLE": "Projects",
      "SUBTITLE": {
        "DUE": "Due",
        "COMPLETED": "Completed"
      },
      "STATUS": {
        "OPEN": "Open",
        "IN_PROGRESS": "In progress",
        "WAITING_ON_CUSTOMER": "Waiting on customer",
        "COMPLETED": "Completed",
        "OVERDUE": "Overdue"
      },
      "NO_PROJECTS": "No projects yet"
    },
    "ORDERS": {
      "TITLE": "Orders"
    },
    "COMPANY_PRIORITIES": {
      "TITLE": "Company Priorities"
    },
    "PROPOSALS": {
      "TITLE": "Proposals"
    },
    "TASKS": {
      "TITLE": "Tasks"
    },
    "PANEL_IN_PROGRESS": {
      "BUTTON": "View / add {{ category }}",
      "DESCRIPTION": "We’re still working on this! To add or view existing {{ category }}, you’ll be taken back to the account details page.",
      "ALERT": {
        "TITLE": "The associations panel is still in progress",
        "DESCRIPTION": "- You'll be taken back to the legacy page to access some features."
      }
    },
    "CONTACT": {
      "TITLE": "Contacts",
      "ADD_ASSOCIATION": "Add contact"
    },
    "REMOVE_DIALOG": {
      "TITLE": "Remove association?",
      "MESSAGE": "{{removeName}} will no longer be associated with {{fromName}}.",
      "CONFIRM": "Remove",
      "CANCEL": "Cancel",
      "SUCCESS": "Association removed",
      "ERROR": "Error removing association"
    },
    "ACCOUNT": {
      "TITLE": "Associated account",
      "CREATE_ACCOUNT": "Create account",
      "CREATE_DESCRIPTION": "Accounts handle the billing relationship with a company. Use them to submit orders, create invoices, and collect payments.",
      "GO_TO_ACCOUNT": "Go to account",
      "OPEN_BUSINESS_APP": "Open in"
    },
    "EDIT_ASSOCIATION_DIALOG": {
      "ACTION": "Edit association tags",
      "TITLE": "Association details",
      "SUCCESS": "Association tags updated",
      "ERROR": "Error updating tags"
    }
  },
  "CONTACT": {
    "TITLE": "Contacts",
    "ADD_OBJECT_BUTTON": "Create contact",
    "VIEW_OBJECT": "View contact",
    "CREATE_PAGE": {
      "TITLE": "Create contact",
      "SAVE": {
        "SUCCESS": "Contact creation was successful",
        "ERROR": "Something went wrong"
      },
      "LOAD": {
        "ERROR": "Something went wrong"
      }
    },
    "EDIT_PAGE": {
      "TITLE": "Edit contact",
      "SAVE": {
        "SUCCESS": "Contact was updated successfully"
      }
    },
    "IMPORT_CONTACTS_PAGE": "Import contacts",
    "CONTACT_PROFILE": {
      "TITLE": "Contact profile",
      "EDIT_CONTACT": "Edit contact",
      "ACTIVITIES_TIMELINE_TAB": "Activity",
      "ABOUT_TAB": "About",
      "ASSOCIATIONS_TAB": "Associations"
    },
    "PROFILE_PAGE": {
      "TITLE": "Contact profile",
      "EDIT": "Edit contact",
      "PREVIOUS_PAGE_TITLE": "contacts",
      "ACTIVITIES_TIMELINE_TAB": "Activity",
      "ABOUT_TAB": "About",
      "ASSOCIATIONS_TAB": "Associations"
    },
    "ACTIVITIES_TIMELINE": {
      "EMPTY": {
        "IMAGE_ALT": "Graphic showing an abstract activity card floating",
        "HEADER": "Activities Timeline",
        "HINT": "Add an Activity"
      },
      "EMPTY_SEARCH": {
        "HEADER": "No activities found that match your search",
        "HINT": "Try changing the keywords"
      },
      "SECTIONS": {
        "UPCOMING": "Upcoming"
      }
    },
    "ACTIVITIES": {
      "UNKNOWN_NAME": "Unknown user",
      "HEADER_ADDITIONAL_TEXT": {
        "NOTE": "added a note",
        "LOGGED_EMAIL": "logged an email",
        "LOGGED_CALL": "logged a call",
        "LOGGED_MEETING": "logged a meeting",
        "LOGGED_COMMUNICATION": "logged a message",
        "TASK": "was assigned a task"
      },
      "CREATED_FROM": "from"
    },
    "RECORD_CHANGE_ACTIVITY": {
      "CREATED": "Contact created",
      "CREATED_VIA": "Contact created via"
    },
    "LIST_OBJECTS_PAGE": {
      "BACK_TO_USERS": "Back to Manage Users"
    },
    "LIST_OBJECTS_TABLE": {
      "EMPTY_TABLE": {
        "IMAGE_ALT": "Graphic showing a contact to be filled in",
        "HEADER": "Create your first contact",
        "HINT": "Add a single contact or import existing contact data from a CSV file"
      },
      "CUSTOM_COLUMNS": {
        "FULL_NAME": "Name",
        "PRIMARY_COMPANY_NAME": "Primary company name"
      },
      "ACTIONS": {
        "EDIT": {
          "TITLE": "Edit contact"
        },
        "DELETE": {
          "ACTION": "Delete contact",
          "TITLE": "Delete contact?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted contact",
          "ERROR": "Error deleting contact"
        },
        "DELETE_SELECTED": {
          "ACTION": "Delete contacts",
          "TITLE": "Delete contacts?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted contacts",
          "ERROR": "Error deleting contacts"
        }
      }
    },
    "TABLE_FILTERS": {
      "HEADER": "Contacts"
    },
    "STANDARD_FIELD_RULES": {
      "UNIQUE_FIELD_VALUE": {
        "ENFORCED": "A contact with this {{label}} already exists",
        "WARNING": "One or more contacts with this {{label}} already exists",
        "PERMISSION_DENIED": "A contact with this {{label}} already exists in your organization"
      }
    },
    "SELECT_MODAL": {
      "ONE_SELECTED": "Add contact",
      "MORE_SELECTED": "Add {{totalSelected}} contacts",
      "NO_SELECTED": "Please select a contact"
    }
  },
  "ACTIVITY_TYPES": {
    "NOTE": "Note",
    "EMAIL": "Email",
    "CALL": "Call",
    "MEETING": "Meeting",
    "CAMPAIGN": "Campaign email",
    "TASK": "Task",
    "MORE": "More",
    "COMMUNICATION_SUBTYPES": {
      "INBOX": "Inbox",
      "SMS": "SMS",
      "LINKEDIN": "LinkedIn"
    }
  },
  "ACTIVITY_LOGGER": {
    "ADD": "Add",
    "LOG_ACTIVITY": "Log activity",
    "CREATE_TASK": "Create task",
    "SAVE": "Save",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Successfully created activity",
    "ERROR_MESSAGE": "There was a problem creating your activity. Please try again.",
    "EDIT_SUCCESS_MESSAGE": "Successfully updated activity",
    "EDIT_ERROR_MESSAGE": "There was a problem updating your activity. Please try again.",
    "ERROR_SET_REQUIRED_FIELDS": "Fill all required fields",
    "ERROR_REQUIRE_DESCRIPTION": "Description is required",
    "ERROR_REQUIRE_EMAIL_DIRECTION": "Email direction is required",
    "ERROR_REQUIRE_CALL_DIRECTION": "Call direction is required",
    "ERROR_REQUIRE_EMAIL_DATE": "Email date is required",
    "ERROR_REQUIRE_CALL_DATE": "Call date is required",
    "ERROR_REQUIRE_MEETING_DATE": "Meeting date is required",
    "ERROR_REQUIRE_TASK_DUE_DATE": "Task due date is required",
    "ERROR_REQUIRE_COMMUNICATION_DATE": "Date is required",
    "ERROR_REQUIRE_TASK_TYPE": "Task type is required",
    "ERROR_REQUIRE_TASK_ASSIGNEE": "Task assignee is required",
    "ERROR_REQUIRE_TASK_NAME_REQUIRED": "Task name is required",
    "ERROR_REQUIRE_COMMUNICATION_OUTCOME": "Outcome is required",
    "NOTE_PLACEHOLDER": "Share an update...",
    "ASSOCIATIONS": "Associations",
    "ADD_COMPANY_ASSOCIATION": "Associate company...",
    "ADD_CONTACT_ASSOCIATION": "Associate contact...",
    "ADD_TEAM_MEMBER_ASSOCIATION": "Add team members...",
    "ADD_OPPORTUNITY_ASSOCIATION": "Associate opportunity...",
    "ADD_TAGS": "Add tags...",
    "TAGS": "Tags",
    "LOGGED_EMAIL": {
      "DATE_PLACEHOLDER": "Email date",
      "DESCRIPTION_PLACEHOLDER": "Describe the email...",
      "DIRECTION_PLACEHOLDER": "Email direction"
    },
    "LOGGED_CALL": {
      "DATE_PLACEHOLDER": "Call date",
      "NOTE_PLACEHOLDER": "Describe the call...",
      "DIRECTION_PLACEHOLDER": "Call direction",
      "OUTCOME_PLACEHOLDER": "Call outcome",
      "STATUS_PLACEHOLDER": "Call status"
    },
    "LOGGED_MEETING": {
      "DATE_PLACEHOLDER": "Meeting date",
      "NOTE_PLACEHOLDER": "Describe the meeting...",
      "DURATION_PLACEHOLDER": "Meeting duration",
      "OUTCOME_PLACEHOLDER": "Meeting outcome",
      "STATUS_PLACEHOLDER": "Meeting status"
    },
    "LOGGED_TASK": {
      "TITLE_PLACEHOLDER": "Add a task",
      "INSTRUCTIONS_PLACEHOLDER": "Add task instructions",
      "PRIORITY_PLACEHOLDER": "Task priority",
      "TYPE_PLACEHOLDER": "Task type",
      "DUE_DATE_PLACEHOLDER": "Task due date",
      "OWNER_PLACEHOLDER": "Task assignee",
      "CREATE": {
        "SUCCESS": "Successfully created task",
        "ERROR": "There was a problem creating your task. Please try again."
      },
      "EDIT": {
        "SUCCESS": "Successfully updated task",
        "ERROR": "There was a problem updating your task. Please try again."
      }
    },
    "LOGGED_COMMUNICATION": {
      "DIRECTION_PLACEHOLDER": "Outcome",
      "DESCRIPTION_PLACEHOLDER": "Share an update..",
      "DATE_PLACEHOLDER": "Date"
    },
    "LOGGED_FOLLOW_UP_TASK": {
      "CREATE": "Create follow-up task",
      "TITLE": "Follow-up task",
      "FOLLOW_UP_WITH": "Follow up with"
    },
    "ACTIVITY_TYPE_SELECTOR_ARIA_LABEL": "Activity type selector"
  },
  "ACTIVITY": {
    "TITLE": "Activity",
    "MENU": {
      "EDIT": "Edit activity"
    },
    "AUDIO_PLAYBACK_ERROR": "Audio playback is not supported",
    "DIRECTION": "Direction",
    "OUTCOME": "Outcome",
    "STATUS": "Status",
    "DATE": "Date",
    "DURATION": "Duration",
    "DUE": "Due",
    "OVERDUE": "Overdue",
    "OUTBOUND": "Outbound",
    "INBOUND": "Inbound",
    "FORWARDED": "Forwarded",
    "OUTCOME_OPTIONS": {
      "BUSINESS_REVIEW": "Business review",
      "DEMO_SCHEDULED": "Demo scheduled",
      "DEMO_COMPLETED": "Demo completed",
      "DISCOVERY": "Discovery",
      "INTERESTED": "Interested",
      "NO_INTEREST": "No interest",
      "PRESENTATION": "Presentation",
      "QUALITY_CONNECT": "Quality connect",
      "RESCHEDULING": "Rescheduling",
      "REFERRED_TO_ANOTHER_CONTACT": "Referred to another contact",
      "TIMELINE_6_12_MONTHS": "Timeline 6-12 months"
    },
    "LOGGED_EMAIL": {
      "DIRECTION": "Email direction"
    },
    "LOGGED_CALL": {
      "DIRECTION": "Call direction",
      "STATUS": "Call status",
      "OUTCOME": "Call outcome"
    },
    "EMAIL_TITLE": {
      "FORWARDED": "forwarded to",
      "INBOUND": "sent to",
      "OUTBOUND": "sent from",
      "BOUNCED": "bounced by",
      "CLICKED": "clicked by",
      "DEFERRED": "deferred for",
      "DELIVERED": "delivered to",
      "DROPPED": "dropped by",
      "FAILED": "failed for",
      "OPENED": "opened by",
      "PROCESSED": "processed for",
      "RECEIVED": "received by",
      "RESUBSCRIBED": "resubscribed by",
      "SENT": "sent to",
      "SPAM": "marked as spam for",
      "UNSUBSCRIBED": "unsubscribed by"
    },
    "TASK": {
      "DUE_DATE": "Due date",
      "ASSIGNED_TO": "Assigned to",
      "TYPE": "Type",
      "PRIORITY": "Priority",
      "LOW": "Low",
      "MEDIUM": "Medium",
      "HIGH": "High",
      "TO_DO": "To-do",
      "EMAIL": "Email",
      "CALL": "Call",
      "MESSAGE": "Message",
      "CONNECTION": "Connection",
      "LINKEDIN": "LinkedIn"
    },
    "MEETING": {
      "SCHEDULED": "Scheduled",
      "RESCHEDULED": "Rescheduled",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled",
      "NO_SHOW": "No show",
      "5_MIN": "5 minutes",
      "15_MIN": "15 minutes",
      "30_MIN": "30 minutes",
      "1_HOUR": "1 hour",
      "1_HOUR_30_MIN": "1 hour 30 minutes",
      "2_HOURS_OR_MORE": "2 hours or more"
    },
    "CALL": {
      "CONNECTED": "Connected",
      "BUSY": "Busy",
      "REJECTED": "Rejected",
      "LEFT_VOICEMAIL": "Left voicemail",
      "NO_ANSWER": "No answer",
      "NOT_IN_SERVICE": "Not in service",
      "WRONG_NUMBER": "Wrong number"
    },
    "COMMUNICATION": {
      "TYPE": "Type",
      "CONVERSATION_CREATED": "Conversation created via"
    },
    "UNKNOWN_TITLE": "An activity occurred",
    "ASSOCIATION": "association",
    "ASSOCIATIONS": "associations",
    "POPOVER": {
      "CONTACTS": "Contacts",
      "COMPANIES": "Companies",
      "OPPORTUNITIES": "Opportunities",
      "TEAM_MEMBERS": "Team members"
    }
  },
  "COMPANY": {
    "TITLE": "Companies",
    "ADD_OBJECT_BUTTON": "Create company",
    "PROSPECT_OBJECT_BUTTON": "Find nearby businesses",
    "VIEW_OBJECT": "View company",
    "DEFAULT_NAME": "this company",
    "CREATE_PAGE": {
      "TITLE": "Create company",
      "SAVE": {
        "SUCCESS": "Company creation was successful"
      }
    },
    "EDIT_PAGE": {
      "TITLE": "Edit company",
      "SAVE": {
        "SUCCESS": "Company was updated successfully"
      }
    },
    "RECORD_CHANGE_ACTIVITY": {
      "CREATED": "Company created",
      "CREATED_VIA": "Company created via",
      "IMPORTANT_FIELD_UPDATED": "{{updatedField}} updated by",
      "IMPORTANT_FIELD_UPDATED_SALESPERSON": "Assigned to",
      "IMPORTANT_FIELD_UPDATED_SALESPERSON_NOT_ASSIGNED": "Unassigned",
      "IMPORTANT_FIELD_UPDATED_SALESPERSON_UNKNOWN": "deleted salesperson"
    },
    "OPPORTUNITY_CHANGE_ACTIVITY": {
      "OPPORTUNITY_UPDATED_BY": "Opportunity updated by",
      "OPPORTUNITY_UPDATED": "Opportunity updated",
      "STATUS_CHANGE_MESSAGE": "Open →",
      "REASON_MESSAGE": "Reason:",
      "NOTES_MESSAGE": "Notes:"
    },
    "PROFILE_PAGE": {
      "TITLE": "Company profile",
      "EDIT": "Edit company",
      "ACTIVITIES_TIMELINE_TAB": "Activity",
      "ABOUT_TAB": "About",
      "ASSOCIATIONS_TAB": "Associations",
      "PREVIOUS_PAGE_TITLE": "Companies"
    },
    "LIST_OBJECTS_PAGE": {
      "BACK_TO_ACCOUNTS": "Back to Manage Accounts"
    },
    "LIST_OBJECTS_TABLE": {
      "EMPTY_TABLE": {
        "IMAGE_ALT": "Graphic showing a company to be filled in",
        "HEADER": "Create your first company",
        "HINT": "Add a single company or import existing company data from a CSV file"
      },
      "ACTIONS": {
        "EDIT": {
          "TITLE": "Edit company"
        },
        "DELETE": {
          "ACTION": "Delete company",
          "TITLE": "Delete company?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted company",
          "ERROR": "Error deleting company"
        },
        "DELETE_SELECTED": {
          "ACTION": "Delete companies",
          "TITLE": "Delete companies?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted companies",
          "ERROR": "Error deleting companies"
        },
        "OPEN_BUSINESS_APP": "Open in",
        "START_AUTOMATION": "Start automation"
      },
      "PROFILE_PAGE": {
        "EDIT": "Edit company"
      }
    },
    "TABLE_FILTERS": {
      "HEADER": "Companies"
    },
    "SELECT_MODAL": {
      "ONE_SELECTED": "Add company",
      "MORE_SELECTED": "Add {{totalSelected}} companies",
      "NO_SELECTED": "Please select a company"
    }
  },
  "TASK": {
    "TITLE": "Tasks",
    "ADD_OBJECT_BUTTON": "Create task",
    "VIEW_OBJECT": "View task",
    "RECORD_CHANGE_ACTIVITY": {
      "CREATED": "Task created",
      "CREATED_VIA": "Task created via"
    },
    "SELECT_MODAL": {
      "ONE_SELECTED": "Add task",
      "MORE_SELECTED": "Add {{totalSelected}} tasks",
      "NO_SELECTED": "Please select a task"
    },
    "CREATE_PAGE": {
      "TITLE": "Create task",
      "SAVE": {
        "SUCCESS": "Task creation was successful",
        "ERROR": "Something went wrong"
      },
      "LOAD": {
        "ERROR": "Something went wrong"
      }
    },
    "EDIT_PAGE": {
      "TITLE": "Edit task",
      "SAVE": {
        "SUCCESS": "Task was updated successfully"
      }
    },
    "LIST_OBJECTS_TABLE": {
      "EMPTY_TABLE": {
        "IMAGE_ALT": "Graphic showing a task to be filled in",
        "HEADER": "Create your first task",
        "HINT": "Track, manage and complete your daily tasks"
      },
      "ACTIONS": {
        "EDIT": {
          "TITLE": "Edit task"
        },
        "DELETE": {
          "ACTION": "Delete task",
          "TITLE": "Delete task?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted task",
          "ERROR": "Error deleting task"
        },
        "DELETE_SELECTED": {
          "ACTION": "Delete tasks",
          "TITLE": "Delete tasks?",
          "CONFIRMATION_MESSAGE": "This cannot be undone.",
          "CONFIRM": "Delete",
          "CANCEL": "Cancel",
          "SUCCESS": "Deleted tasks",
          "ERROR": "Error deleting tasks"
        },
        "CREATE": {
          "TITLE": "Create task"
        },
        "TASK_QUEUE": {
          "START": "Start {{count}} tasks",
          "NO_TASKS_SELECTED": "No tasks selected to start working on",
          "ASSOCIATIONS_CHIP": "{{count}} associations"
        }
      },
      "CUSTOM_COLUMNS": {
        "ASSIGNED_TO": "Assigned to",
        "DAYS_OVERDUE": "Overdue {{ amount }} days",
        "HOURS_OVERDUE": "Overdue {{ amount }} hours"
      }
    },
    "TABLE_FILTERS": {
      "HEADER": "Tasks"
    },
    "STATUS_UPDATE": {
      "SUCCESS": "Task status updated",
      "ERROR": "Task status update failed"
    }
  },
  "LIST_OBJECTS_TABLE": {
    "CUSTOM_COLUMNS": {
      "FULL_ADDRESS": "Address"
    },
    "ACTIONS": {
      "DELETE": {
        "MODAL_TITLE": "Delete {{name}}?"
      }
    },
    "ACTIONS_COLUMN": {
      "TITLE": "Actions"
    },
    "CREATED_COLUMN": {
      "TITLE": "Created"
    },
    "DATE_DEFAULT": {
      "INVALID": "Exact date",
      "TODAY": "Today",
      "YESTERDAY": "Yesterday",
      "TOMORROW": "Tomorrow",
      "THIS_WEEK": "This week",
      "LAST_WEEK": "Last week",
      "NEXT_WEEK": "Next week",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "NEXT_MONTH": "Next month",
      "THIS_QUARTER": "This quarter",
      "LAST_QUARTER": "Last quarter",
      "NEXT_QUARTER": "Next quarter",
      "THIS_YEAR": "This year",
      "LAST_YEAR": "Last year",
      "NEXT_YEAR": "Next year"
    },
    "EXTERNAL_ID_COLUMN": {
      "TITLE": "External ID"
    },
    "ID_COLUMN": {
      "TITLE": "ID"
    },
    "UPDATED_COLUMN": {
      "TITLE": "Updated"
    },
    "STANDARD_FIELD_RULES": {
      "UNIQUE_FIELD_VALUE": {
        "ENFORCED": "A company with this {{label}} already exists",
        "WARNING": "One or more companies with this {{label}} already exists"
      }
    }
  },
  "CRM_FORM_SERVICE": {
    "RESOURCE_NOT_FOUND_ERROR": "Resource not found"
  },
  "STANDARD_FIELD_GROUPS": {
    "CONTACT": {
      "BASIC_INFORMATION": "Basic information",
      "BASIC_GROUP2_INFORMATION": "Primary location",
      "BASIC_GROUP3_INFORMATION": "About contact"
    },
    "COMPANY": {
      "BASIC_INFORMATION": "Basic information",
      "ADDITIONAL_INFORMATION": "Additional information"
    },
    "CUSTOM_FIELDS": "Custom fields"
  },
  "STANDARD_FIELD_RULES": {
    "CONTACT": {
      "FIRST_OR_LAST_NAME_OR_PHONE_OR_EMAIL_REQUIRED": "One of first name, last name, phone or email is required"
    },
    "COMPANY": {
      "COMPANY_NAME_REQUIRED": "Company name is required"
    }
  },
  "PAGE_NOT_FOUND": {
    "HEADER": "404 Not Found",
    "HINT": "The page or information requested could not be found."
  },
  "BULK_IMPORT": {
    "UPLOAD_CSV_STEP": {
      "TITLE": "Upload CSV",
      "INSTRUCTIONS": "Upload an existing CSV of customer data.",
      "REQUIREMENTS": "A name, phone number <strong>OR</strong> email must be included for each customer.",
      "MAXIMUM_FILE_SIZE": "Maximum File Size: 5MB",
      "REQUIRED": "This field is required",
      "SUCCESSFUL_UPLOAD": "Successfully uploaded {{filename}}"
    },
    "MAP_FIELDS_STEP": {
      "TITLE": "Map fields",
      "INSTRUCTIONS": "Confirm that the columns in your file map to the correct fields. A name, phone number <strong>OR</strong> email must be selected.",
      "COLUMNS": "Columns",
      "FIRST_ROW": "First row",
      "MAP_TO": "Map to",
      "ARIA_LABEL": "Map to fields",
      "OTHER_FIELDS": "Other fields",
      "DO_NOT_IMPORT": "Do not import",
      "REQUIRED": "Mapping a name, phone number OR email is required to proceed",
      "UNABLE_TO_MAP_FIELD": "{{fieldName}} is already mapped to {{header}}"
    },
    "REVIEW_IMPORT_STEP": {
      "TITLE": "Review import",
      "INSTRUCTIONS": "Importing this will take several minutes depending on the number of customers you are creating.",
      "ESTIMATED_TOTAL": "an estimated total of ",
      "ADDING_CUSTOMERS_FROM_FILENAME": "Adding {{estimatedText}}<strong>{{rows}}</strong> customers from {{csvFilename}}.",
      "UPDATE_DUPLICATES": "Update existing contacts",
      "UPDATE_DUPLICATES_INSTRUCTIONS": "If contacts with existing emails are detected, update them with any new information found in this file.",
      "UPDATE_DUPLICATES_TOOLTIP": "If this is not selected, existing contacts will be skipped. This will detect duplicates based on the ID field, external ID field, and fields marked unique like email."
    },
    "IMPORT_SUCCESS": "Started import for {{filename}}",
    "IMPORT_ERROR": "Uh-oh. Looks like something went wrong on our end. Please try again."
  },
  "TABLE_FILTERS": {
    "ADD_FILTER": "Add filter",
    "CLEAR_FILTERS": "Clear all",
    "FIND_FILTER": "Find filter",
    "INVALID_FILTER_TYPE": "Filter type is invalid",
    "INCOMPLETE_FILTER": "Filter is incomplete. Complete the filter before applying it.",
    "SELECT_OPERATOR_PLACEHOLDER": "Select operator...",
    "SELECT_EXPRESSION_PLACEHOLDER": "Select...",
    "SELECT_START_PLACEHOLDER": "Start date",
    "SELECT_END_PLACEHOLDER": "End date",
    "OPERATOR": {
      "INVALID": "invalid",
      "IS_EMPTY": "✕ is empty",
      "IS_NOT_EMPTY": "✓ is not empty",
      "IS": "= is",
      "IS_NOT": "≠ is not",
      "IS_ANY": "∋ is any of",
      "IS_NOT_ANY": "∌ is not any of",
      "IS_ALL": "= is all of",
      "IS_NOT_ALL": "≠ is not all of",
      "CONTAINS": "∋ contains",
      "DOES_NOT_CONTAIN": "∌ does not contain",
      "IS_EQUAL_TO": "= is equal to",
      "IS_NOT_EQUAL_TO": "≠ is not equal to",
      "IS_GREATER_THAN": "> is greater than",
      "IS_GREATER_THAN_OR_EQUAL_TO": "≥ is greater than or equal to",
      "IS_LESS_THAN": "< is less than",
      "IS_LESS_THAN_OR_EQUAL_TO": "≤ is less than or equal to",
      "IS_BEFORE": "< is before",
      "IS_BEFORE_OR_ON": "≤ is before or on",
      "IS_AFTER": "> is after",
      "IS_AFTER_OR_ON": "≥ is after or on",
      "IS_BETWEEN": "= is between",
      "IS_NOT_BETWEEN": "≠ is not between"
    },
    "SYMBOL": {
      "INVALID": "is INVALID",
      "IS_EMPTY": "✕",
      "IS_NOT_EMPTY": "✓",
      "IS": "=",
      "IS_NOT": "≠",
      "IS_ANY": "∋",
      "IS_NOT_ANY": "∌",
      "IS_ALL": "=",
      "IS_NOT_ALL": "≠",
      "CONTAINS": "∋",
      "DOES_NOT_CONTAIN": "∌",
      "IS_EQUAL_TO": "=",
      "IS_NOT_EQUAL_TO": "≠",
      "IS_GREATER_THAN": ">",
      "IS_GREATER_THAN_OR_EQUAL_TO": "≥",
      "IS_LESS_THAN": "<",
      "IS_LESS_THAN_OR_EQUAL_TO": "≤",
      "IS_BEFORE": "<",
      "IS_BEFORE_OR_ON": "≤",
      "IS_AFTER": ">",
      "IS_AFTER_OR_ON": "≥",
      "IS_BETWEEN": "=",
      "IS_NOT_BETWEEN": "≠"
    }
  },
  "MODEL_DRIVEN_FORM": {
    "LOADING_STATUS_ERROR": {
      "TITLE": "Something went wrong",
      "TEXT": "Please wait a few moments and try again. If the problem persists, please contact an administrator"
    },
    "STRING_LIMIT_HINT": "Maximum {{characters}} characters",
    "TAG_LIMIT_ERROR": "Only {{maximumTags}} tags are allowed",
    "INVALID_DROPDOWN_ERROR": "Select a valid option",
    "SUBMITTED_PRISTINE": "You have not made any changes.",
    "SUBMITTED_WITH_ERROR": "Failed to create object. Please ensure that fields are filled out correctly.",
    "INVALID_EMAIL_ERROR": "Email entered is invalid",
    "ADD_TAG_PROMPT": "Add a tag...",
    "ADD_STRINGLIST_ITEM_PROMPT": "Add an item...",
    "PHONE": {
      "INVALID_PHONE_ERROR": "Phone number entered is invalid",
      "COUNTRY_LABEL": "Area code",
      "EXTENSION_LABEL": "Extension",
      "SEARCH_COUNTRY_LABEL": "Search",
      "SEARCH_COUNTRY_NO_RESULTS": "No results found"
    },
    "BOOLEAN": {
      "TRUE": "Yes",
      "FALSE": "No"
    },
    "ADD_FIELD_VALUE": "Add {{fieldName}}...",
    "EDIT_FIELD": "Edit field"
  },
  "COLLAPSIBLE_SECTION": {
    "VIEW_MORE": "View more",
    "VIEW_LESS": "View less"
  },
  "PERMISSION": {
    "TITLE": "Permission required",
    "DESCRIPTION": "You don't have the necessary permissions to view this page. <br/>Request access from your administrator.",
    "PREV_PAGE": "Back to previous page",
    "HOME_PAGE": "Go to home page",
    "IMAGE_ALT": "Graphic showing denied access due to permissions"
  },
  "CAMPAIGNS": {
    "TITLE": "Campaigns",
    "NO_CAMPAIGNS": "No email campaigns have been started for this account",
    "CONTACTS": {
      "MODAL": {
        "SELECT_ALL_SUCCESS": "{{ totalObjects }} contacts added to campaign: {{ campaignTitle }}",
        "ID": "ID",
        "NAME": "Name",
        "EMAIL": "Email",
        "NO_CAMPAIGNS": "No campaigns found",
        "PUBLISH": "Publish now",
        "BACK": "Back",
        "START_CAMPAIGN": "Start campaign",
        "CANCEL": "Cancel",
        "RECIPIENT_COUNT": "Estimated recipients: {{recipientCount}}",
        "UPDATED": "Last updated: ",
        "SELECT_CAMPAIGN": "Add {{recipientCount}} recipients to campaign",
        "MISSING_EMAIL_ADDRESS": "{{contactCount}} missing email addresses — ",
        "MISSING_EMAIL": "contacts without email addresses will not receive campaign emails.",
        "SEARCH_PLACEHOLDER": "Search active campaigns",
        "RECIPIENTS_TOOLTIP": "The recipient count is an estimate, as it doesn't account for contacts who have unsubscribed, are already on the campaign, or have invalid or missing email addresses.",
        "ERRORS": {
          "GENERIC_ERROR": "There was a problem starting the campaign. Please try again.",
          "FAILED_ADDRESS_ERROR": "'Failed to add the following addresses: '",
          "NO_CAMPAIGN_SELECTED": "Please select a campaign"
        },
        "SUCCESS": "recipients added to campaign: "
      }
    }
  },
  "VIEWS": {
    "ACTIONS": {
      "CREATE_VIEW": "Create view"
    },
    "DELETE_CONFIRMATION": {
      "TITLE": "Delete view?",
      "MESSAGE": "{{ viewName }} will be deleted."
    },
    "EMPTY": "Add filters to create a view",
    "ERRORS": {
      "VIEW_NAME_REQUIRED": "View name is required",
      "EQUAL_TO_PRESET_NAME": "View name cannot be an existing name",
      "VIEW_NAME_TOO_LONG": "View name cannot be longer than 36 characters",
      "NO_FILTERS": "Add filters before creating a view"
    },
    "VIEW_NAME": "View name",
    "VIEWS": "Views",
    "PRESET_FILTERS": {
      "ALL": "All",
      "NOTES": "Notes",
      "TASKS": "Tasks",
      "EMAILS": "Emails",
      "CALLS": "Calls",
      "MEETINGS": "Meetings",
      "COMMUNICATIONS": "Communications"
    }
  },
  "LIFECYCLE_STAGE": {
    "VISITOR": "Visitor",
    "LEAD": "Lead",
    "MARKETING_QUALIFIED_LEAD": "Marketing qualified lead",
    "SALES_ACCEPTED_LEAD": "Sales accepted lead",
    "SALES_QUALIFIED_LEAD": "Sales qualified lead",
    "PROSPECT": "Prospect",
    "CUSTOMER": "Customer",
    "FORMER_CUSTOMER": "Former customer"
  },
  "TASK_QUEUE": {
    "ACTIONS": {
      "SKIP": "Skip",
      "MARK_AS_COMPLETE": "Mark as complete",
      "UNDO": "Undo",
      "NEXT": "Next",
      "BACK_TO_TASKS": "Back to tasks",
      "RESCHEDULE": "Reschedule"
    },
    "STATUS": {
      "COMPLETED": "Completed",
      "RESCHEDULED": "Rescheduled"
    },
    "TASKS": "Tasks",
    "RESCHEDULE_TASK": "Reschedule task",
    "ERRORS": {
      "MARK_AS_COMPLETE": "There was a problem marking the task as completey. Please try again.",
      "RESCHEDULE": "There was a problem rescheduling the task. Please try again.",
      "UNDO": "There was a problem updating the task. Please try again.",
      "INVALID_DUE_DATE": "Invalid due date"
    },
    "SUCCESS_MESSAGES": {
      "RESCHEDULE": "Task rescheduled"
    }
  },
  "COMMON": {
    "SNACKBAR_MESSAGE": {
      "COPY_SUCCESS": "Successfully copied to clipboard"
    }
  }
}
